import { useNavigate } from "react-router-dom";
import MypostProperty from "../../../../components/pages/profile/MypostProperty";
import { useMyProperties } from "../../../../hooks/pages/account/useMyProperties";
import { PropertyFilters } from "../../../../components/pages/account/PropertyFilters";
import { Pagination } from "../../../../components/pages/account/Pagination";

export default function MyProperties() {
  const navigate = useNavigate();
  const {
    properties,
    loading,
    filters,
    page,
    totalPages,
    handleFilterChange,
    handleDelete,
    setPage,
  } = useMyProperties();

  const handleEdit = (property) => navigate(`/edit-property/${property.id}`);

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Bất động sản bạn đã đăng</h1>

      <PropertyFilters filters={filters} onChange={handleFilterChange} />

      {loading ? (
        <p>Đang tải dữ liệu...</p>
      ) : properties.length === 0 ? (
        <p>Bạn chưa đăng bất động sản nào.</p>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {properties.map((property) => (
              <MypostProperty
                key={property.id}
                property={property}
                onEdit={handleEdit}
                onDelete={handleDelete}
              />
            ))}
          </div>

          <Pagination
            page={page}
            totalPages={totalPages}
            onPrev={() => setPage((p) => p - 1)}
            onNext={() => setPage((p) => p + 1)}
          />
        </>
      )}
    </div>
  );
}